// src/hooks/useFetchSinglePack.js
import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue, off } from "firebase/database";

/**
 * Fetches a single pack under `/Packs/{domainId}/{packId}`
 */
export default function useFetchSinglePack(domainId, packId) {
    const [pack, setPack] = useState(null);
    const [loadingPack, setLoadingPack] = useState(true);

    useEffect(() => {
        if (!domainId || !packId) return;
        const packRef = ref(db, `Packs/${domainId}/${packId}`);

        const unsubscribe = onValue(packRef, (snapshot) => {
            const data = snapshot.val();
            setPack(data || null);
            setLoadingPack(false);
        });

        return () => {
            off(packRef);
            unsubscribe();
        };
    }, [domainId, packId]);

    return { pack, loadingPack };
}
